import { Component, OnInit } from '@angular/core';
import { General_Config } from '../General_Config';
import { CommonFunctionsService } from '../common-functions.service';
import { RestApiService } from '../rest-api.service';
import { ModalController, AlertController } from '@ionic/angular';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-report',
  templateUrl: './report.page.html',
  styleUrls: ['./report.page.scss'],
})
export class ReportPage implements OnInit {
  report_type: string = 'sales';
  isLoadingPDF: boolean = false;
  isLoadingExcel: boolean = false;
  products: any = [];
  dataForm: FormGroup;
  constructor(public alertController: AlertController, public modalController: ModalController, public restApi: RestApiService, public commonFunctions: CommonFunctionsService) {
    General_Config.active_page = 'Report';
  }

  ngOnInit() {
    this.dataForm = new FormGroup({
      'start_date': new FormControl(null, [Validators.required]),
      'end_date': new FormControl(null, [Validators.required]),
    });
  }
  
  generatePDFReport() {
    this.isLoadingPDF = true;
    this.restApi.post('shopadmin_report_pdf/' + this.report_type, this.dataForm.value).subscribe((data: any) => {
      this.isLoadingPDF = false;
      if (data['code'] == 200) {
        window.open(General_Config.image_base + data['data'], '_blank');
      } else {
        this.commonFunctions.presentAlertConfirm('Information', data['message']);
      }
    }, (error: any) => {
      this.isLoadingPDF = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

  generateExcelReport() {
    this.isLoadingExcel = true;
    this.restApi.post('shopadmin_report_excel/' + this.report_type, this.dataForm.value).subscribe((data: any) => {
      this.isLoadingExcel = false;
      if (data['code'] == 200) {
        window.open(General_Config.image_base + data['data'], '_blank');
      } else {
        this.commonFunctions.presentAlertConfirm('Information', data['message']);
      }
    }, (error: any) => {
      this.isLoadingExcel = false;
      this.commonFunctions.presentAlertConfirm('Information', error);
    });
  }

}
